<template>
  <Day day="17.12.2025">
    <div slot="page-content">
      <h3>Cool Lady 😎</h3>
      <p>
        <img src="@/assets/day17.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day17',
  components: {
    Day
  }
}
</script>
